'use client';

import { useBranding } from '@gitroom/frontend/components/branding/branding.context';
import { useT } from '@gitroom/react/translation/get.transation.service.client';
import { TestimonialComponent } from '@gitroom/frontend/components/auth/testimonial.component';

export const AuthMarketingPanel = () => {
  const t = useT();
  const { branding } = useBranding();

  return (
    <div className="hidden flex-1 flex-col items-center pt-[88px] text-[36px] lg:flex">
      <div className="text-center">
        {t('auth_marketing_prefix', 'Mais de')}{' '}
        <span className="text-[42px] text-[#FC69FF]">20.000+</span>{' '}
        {t('auth_marketing_middle', 'empresários usam')}
        <br />
        {branding.brandName}{' '}
        {t(
          'auth_marketing_suffix',
          'para crescer a presença nas redes sociais'
        )}
      </div>
      <TestimonialComponent />
    </div>
  );
};
